import {combineReducers} from "redux";
import data from "components/bng/pages/bigTable/redux/reducers/data";

export default combineReducers({data});